var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0799 12.3805C6.12749 12.5032 6.19886 12.6152 6.2899 12.7103L11.2899 17.7062C11.3831 17.7993 11.4938 17.8732 11.6156 17.9236C11.7375 17.974 11.868 18 11.9999 18C12.2662 18 12.5216 17.8943 12.7099 17.7062C12.8031 17.613 12.8771 17.5024 12.9276 17.3807C12.978 17.2589 13.004 17.1285 13.004 16.9967C13.004 16.7307 12.8982 16.4755 12.7099 16.2873L9.4099 13L16.9999 13C17.2651 13 17.5195 12.8948 17.707 12.7074C17.8945 12.52 17.9999 12.2659 17.9999 12.0009C17.9999 11.7359 17.8945 11.4817 17.707 11.2943C17.5195 11.1069 17.2651 11.0017 16.9999 11.0017L9.4099 11.0017L12.7099 7.71438C12.8036 7.6215 12.878 7.51099 12.9288 7.38923C12.9796 7.26747 13.0057 7.13687 13.0057 7.00497C13.0057 6.87307 12.9796 6.74247 12.9288 6.62071C12.878 6.49895 12.8036 6.38844 12.7099 6.29556C12.6169 6.2019 12.5063 6.12757 12.3845 6.07684C12.2626 6.02612 12.1319 6 11.9999 6C11.8679 6 11.7372 6.02612 11.6153 6.07684C11.4935 6.12757 11.3829 6.2019 11.2899 6.29556L6.2899 11.2914C6.19886 11.3865 6.12749 11.4985 6.0799 11.6212C5.97988 11.8644 5.97988 12.1373 6.0799 12.3805Z",
    fill: "url(#paint0_linear_8_902)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_902",
    x1: 10.8366,
    y1: 18,
    x2: 13.1701,
    y2: 6.00036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.ce9f9a1fe130d69bc93f809fc47a3cc0.svg";
export { ForwardRef as ReactComponent };